export const TRUNCATE_MIDDLE_TAG_NAME = "truncateMiddle" as const;

export const DEFAULT_MIN_CHARS = 4;
